/* tslint:disable */
import {
  Company,
  StockWarehouseLocation,
  Groups
} from '../index';

declare var Object: any;
export interface UsersInterface {
  "id"?: number;
  "name"?: string;
  "active"?: boolean;
  "company_id"?: number;
  "wcp_location"?: number;
  "company_ids"?: Array<any>;
  "groups_id"?: Array<any>;
  company?: Company;
  wcpLocation?: StockWarehouseLocation;
  companies?: Company[];
  groups?: Groups[];
}

export class Users implements UsersInterface {
  "id": number;
  "name": string;
  "active": boolean;
  "company_id": number;
  "wcp_location": number;
  "company_ids": Array<any>;
  "groups_id": Array<any>;
  company: Company;
  wcpLocation: StockWarehouseLocation;
  companies: Company[];
  groups: Groups[];
  constructor(data?: UsersInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Users`.
   */
  public static getModelName() {
    return "Users";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Users for dynamic purposes.
  **/
  public static factory(data: UsersInterface): Users{
    return new Users(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Users',
      plural: 'Users',
      path: 'Users',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "wcp_location": {
          name: 'wcp_location',
          type: 'number'
        },
        "company_ids": {
          name: 'company_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "groups_id": {
          name: 'groups_id',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
      },
      relations: {
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        wcpLocation: {
          name: 'wcpLocation',
          type: 'StockWarehouseLocation',
          model: 'StockWarehouseLocation',
          relationType: 'belongsTo',
                  keyFrom: 'wcp_location',
          keyTo: 'id'
        },
        companies: {
          name: 'companies',
          type: 'Company[]',
          model: 'Company',
          relationType: 'referencesMany',
                  keyFrom: 'company_ids',
          keyTo: 'id'
        },
        groups: {
          name: 'groups',
          type: 'Groups[]',
          model: 'Groups',
          relationType: 'referencesMany',
                  keyFrom: 'groups_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Users.ts